// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__4egWY","img":"Logo_img__LdRhM","title":"Logo_title__AKP7m","subtitle":"Logo_subtitle__rfzkw"};